export default "__VITE_ASSET__f807e668__"